module.exports = __webpack_public_path__ + "img/LOGO_white@2x.146988bc.png";